module.exports = __webpack_public_path__ + "img/cancelado.97eb88b4.png";